// Enabled only after the official assets pass download/integrity verification.
export const FACE_FINDER_AVAILABLE = false;
export const FACE_ASSET_DIRECTORY = 'face-finder/mediapipe-0.10.21-blazeface-1';
